import Api from "./ApiNode";

export default {
  getAllItems(payload) {
    return Api().get("item-master/", { params: payload });
  },
  getItemById(id) {
    return Api().get(`item-master/${id}`);
  },
  createItem(payload) {
    return Api().post("item-master/", payload);
  },
  updateItem(id, payload) {
    return Api().put(`item-master/${id}`, payload);
  },
  deleteItem(id) {
    return Api().delete(`item-master/${id}`);
  },
  bulkUpload(payload) {
    return Api().post("item-master/bulk-upload", payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/ItemMasterService.js